





import Button from '@/types/components/Button.interface'
import PersonProperty from '@/types/PersonProperty.interface'
import SupportPlaceholder from '@/components/SupportPlaceholder.vue'
import Vue from 'vue'
export default Vue.extend({
    components: { SupportPlaceholder },
    computed: {
        isApp(): boolean {
            return this.$store.getters.isApp
        },
        placeholder(): object {
            return {
                title: 'Import new data or export your existing MessageDesk data.',
                content: `Checkout our Learning Center for support articles on how to import data into MessageDesk!`,
                subject: 'CSV Upload Help',
                video: 'https://www.loom.com/embed/11dbd811cb644dfcb6f5a6645b3c4b3d',
                articles: [
                    {
                        name: 'How to Import Data into MessageDesk',
                        href: `${process.env.VUE_APP_URL_LEARN}/en/articles/4527053-how-to-import-contacts-into-messagedesk`
                    }
                ],
                buttons: [
                    {
                        text: 'Export Data',
                        icon: 'mdi-cloud-download',
                        color: 'primary',
                        outlined: true,
                        disabled: this.isApp,
                        callback: () => this.csvExportConfirm()
                    },
                    {
                        text: 'Import Data',
                        icon: 'mdi-cloud-upload',
                        color: 'primary',
                        dark: true,
                        callback: () => this.$emit('next')
                    }
                ] as Button[]
            }
        }
    },
    methods: {
        async csvExport(selected: PersonProperty[]): Promise<void> {
            //  Send the export request to the API
            const response = await this.$store.dispatch('csvExport', {
                selected: selected
            })

            //  If the request failed, do nothing
            if (!response) return

            //  Else, start the progress spinner
            this.$store.commit('csvExportProgressSet', {
                percent: 0,
                message: 'Beginning Export'
            })

            //  Notify user of export
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Export in Progress',
                icon: 'mdi-database-export',
                text: response.message
            })
        },
        csvExportConfirm(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Export Confirmation (.csv)',
                icon: 'mdi-cloud-download',
                color: 'primary',
                component: 'csv-export-fields',
                callback: async (selected: PersonProperty[]): Promise<void> => {
                    //  Close this dialog
                    await this.$store.dispatch('dialogClose', 'APP')

                    //  Begin export
                    this.csvExport(selected)
                }
            })
        }
    }
})
